/**
 * @file 加密串处理
*/
import { report } from '@tencent/ppd-report-sdk-web';
import { CustomException } from '@/utils/error';

const encryptedInfoLength = 23;

/**
 * 从url中获取参数a
 */
export function initParameterA(paramsEncryptedInfo: string) {
  // 从路径参数或query参数中获取加密串
  let encryptedInfo = paramsEncryptedInfo;
  // 如果链接中没有a
  if (!encryptedInfo) {
    new CustomException(null, 'noEncryptedInfo', 'url缺少加密串信息');
    return '';
  }

  // 上报加密串长度
  report.reportEvent({
    key: 'encrypted_info_length',
    message: encryptedInfo.length.toString(),
  });

  // 如果加密串小于23位，则无法获取到完整的加密串。则隐藏按钮+展示客服小程序码引导用户联系客服
  if (encryptedInfo.length < encryptedInfoLength) {
    new CustomException(
      `${encryptedInfo.length}`,
      'encryptedInfoTooShort',
      '加密串过短',
    );
    return '';
  }

  if (encryptedInfo.length > encryptedInfoLength) {
    new CustomException(
      `${encryptedInfo.length}`,
      'encryptedInfoTooLong',
      '加密串过长',
    );
  }

  // 去除参数a中的空格
  encryptedInfo = encryptedInfo.replace(/\s*/g, '');

  // 如果链接长度大于23位，则只取前23位字符
  encryptedInfo = encryptedInfo.length <= encryptedInfoLength
    ? encryptedInfo
    : encryptedInfo.slice(0, encryptedInfoLength);

  return encryptedInfo;
}
